import { render } from "./Default.vue?vue&type=template&id=f6c152bc&scoped=true"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"

import "./Default.vue?vue&type=style&index=0&id=f6c152bc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6c152bc"]])

export default __exports__